import { IMyFilesMediaItem, IUploadMediaItem } from 'types/media'
import { IReferenceImage } from 'store/types/aiImage'
import { generateRandomNumberId } from 'utils'

interface IConvertOptions {
  defaultWidth?: number
  defaultHeight?: number
}

export const convertMediaFilesToReferenceImages = (
  files: IMyFilesMediaItem[],
  options: IConvertOptions = {}
): IReferenceImage[] => {
  const { defaultWidth = 100, defaultHeight = 100 } = options

  return files.map(file => ({
    id: file.id,
    url: file.filePath,
    thumbnailUrl: file.filePath,
    width: defaultWidth,
    height: defaultHeight
  }))
}

export const convertImgFilesToMediaItem = (
  files: File[] | FileList
): IUploadMediaItem[] => {
  const filesArray = Array.from(files)

  return filesArray.map(file => ({
    file,
    id: generateRandomNumberId(),
    type: 'image'
  }))
}
